import { ApolloClient, ApolloLink } from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import * as Sentry from '@sentry/react';
import {
  InMemoryCache,
  IntrospectionFragmentMatcher
} from 'apollo-cache-inmemory';
import { RestLink } from 'apollo-link-rest';
import { disableFragmentWarnings } from 'graphql-tag';

import { env } from '@/constant/env';
import { dataIdFromObject } from '@/utils';
import { SpanType } from '../../tracing';
import errorLink from './errorLink';
import introspectionQueryResultData from './fragmentTypesAccount.json' with {
  type: 'json'
};

// Disable warning if multiple fragments have the same name.
disableFragmentWarnings();

const cache = new InMemoryCache({
  dataIdFromObject,
  fragmentMatcher: new IntrospectionFragmentMatcher({
    introspectionQueryResultData
  })
});

const httpLink = new BatchHttpLink({
  uri: `${env.VITE_ACCOUNT_API_URL}/graphql`,
  credentials: 'include',
  fetch: (uri, options) =>
    Sentry.startSpan(
      {
        name: uri,
        op: SpanType.reqOut
      },
      () => fetch(uri, options)
    )
});

const restLink = new RestLink({
  uri: env.VITE_ACCOUNT_API_URL,
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json'
  },
  fetch: (uri, options) =>
    Sentry.startSpan(
      {
        name: uri,
        op: SpanType.reqOut
      },
      () => fetch(uri, options)
    )
});

export default new ApolloClient({
  link: ApolloLink.from([errorLink, restLink, httpLink]),
  cache,
  connectToDevTools: true
});
